export const wrapperStyles = {
  bg: "grayScale.1",
  p: [0, 0]
};
